import { render, staticRenderFns } from "./MudNew.vue?vue&type=template&id=58c97a77&"
import script from "./MudNew.vue?vue&type=script&lang=js&"
export * from "./MudNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports